<template>
  <article class="section section--full-width">
    <header key="header" class="section__header section__header--info">
      <h2 class="section__title">{{ sectionTitle }}</h2>

      <span
        v-if="sectionTitle === 'Agendamentos'"
        :data-tooltip="info"
        class="tooltip tooltip-top page-info"
      >
        <dr-icon
          class="v-icon"
          color="silver"
          name="info"
        />
      </span>
    </header>

    <transition name="fade" mode="out-in">
      <router-view :doctor="doctor" />
    </transition>

    <footer class="section__footer"></footer>
  </article>
</template>

<script>
export default {
  props: {
    doctor: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      info: `Nesta página você encontra a lista com os\nagendamentos de todos os seus consultórios.`
    }
  },

  computed: {
    sectionTitle () {
      return this.$route.name.indexOf('List') > -1
        ? 'Agendamentos'
        : this.$route.name.indexOf('Guide') > -1
          ? 'Guia de consulta médica'
          : ''
    }
  }
}
</script>
